export const createActionTypes = (name) => ({
  REQUEST: `${name}_REQUEST`,
  SUCCESS: `${name}_SUCCESS`,
  FAIL: `${name}_FAIL`,
});
